import { z } from 'zod'

export const SearchDeviceConfigVariablesSchema = z.object({
    path: z.array(z.string()),
    value: z.string()
})

export type SearchDeviceConfigVariables = z.infer<typeof SearchDeviceConfigVariablesSchema>

const DeviceConfigMatchSchema = z.object({
    device_name: z.string().nullish(),
    device_uuid: z.string().nullish(),
    general_config: z.any()
})

export const SearchDeviceConfigQuerySchema = z.object({
    matching_devices: z.array(DeviceConfigMatchSchema),
    non_matching_devices: z.array(DeviceConfigMatchSchema)
})

export type SearchDeviceConfigQuery = z.infer<typeof SearchDeviceConfigQuerySchema>
